import { createElement, ReactNode } from 'react'
import { FieldType } from '@indigohive/cogfy-types'
import { FIELD_ICONS_BY_TYPE } from '../../field-types'

export type CustomSelectionMenuItemProps = {
  onChange: (event: { target: { value: string } }) => void
  value: string
  label: ReactNode
  disabled?: boolean
  outputType?: FieldType
  setSelectEl: (el: HTMLDivElement | null) => void
}

export function CustomSelectionMenuItem (props: CustomSelectionMenuItemProps) {
  const { value, label, onChange, setSelectEl, outputType } = props
  return (
    <li
      value={value}
      onClick={() => {
        onChange({ target: { value } })
        setSelectEl(null)
      }}
    >
      <span>
        {value && outputType && (
          createElement(
            FIELD_ICONS_BY_TYPE[outputType],
            { size: 16 }
          )
        )}
        <a>
          {label}
        </a>
      </span>
    </li>
  )
}
